import { makeStyles } from '@material-ui/core/styles';

export const useMetaRowsSectionsStyles = makeStyles(theme => ({
  buttonContainer: {
    padding: theme.spacing(0.5, 0)
  },
  disabled: {
    color: theme.palette.grey[500]
  },
  emailBody: {
    overflowX: 'auto',
    padding: theme.spacing(1.5, 3, 0, 1),
    '& img': {
      maxWidth: '99%'
    }
  },
  metaSection: {
    overflowX: 'hidden',
    padding: theme.spacing(0, 2)
  },
  subjectContainer: {
    padding: theme.spacing(1)
  }
}));
